import { render, staticRenderFns } from "./messageGather.vue?vue&type=template&id=5f84575a&"
import script from "./messageGather.vue?vue&type=script&lang=js&"
export * from "./messageGather.vue?vue&type=script&lang=js&"
import style0 from "./messageGather.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports